<template>
  <smd-one-col-layout>
    <div class="freestylelibre-sign-up">
      <div class="freestylelibre-sign-up__header">
        <text-string label-id="txt1449"/>
        <text-string label-id="txt1453"/>
      </div>

      <form class="freestylelibre-sign-up__form">
        <div class="personal-details">
          <div class="smd-form__row">
            <div class="smd-form__col">
              <label required
                    normal
                    for="firstname"
                    :error="$v.firstname.$invalid && $v.firstname.$error">
                First Name
                <span class="form-error-text"
                      v-if="$v.firstname.$invalid && $v.firstname.$error">
                  {{ validationErrors.firstname }}
                </span>
              </label>
              <input v-model="$v.firstname.$model"
                    type="text"
                    id="firstname"
                    placeholder="First Name"
                    :error="$v.firstname.$invalid && $v.firstname.$error"
                    :has-value="!$v.firstname.$invalid"
                    ref="firstname"/>
            </div>
            <div class="smd-form__col">
              <label required
                    normal
                    for="middlename"
                   :error="$v.middlename.$invalid && $v.middlename.$error">
                Middle Name
                <span class="form-error-text"
                      v-if="$v.middlename.$invalid && $v.middlename.$error">
                  {{ validationErrors.middlename }}
                </span>
              </label>
              <input v-model="$v.middlename.$model"
                    type="text"
                    id="middlename"
                    placeholder="Middle Name"
                    :error="$v.middlename.$invalid && $v.middlename.$error"
                    :has-value="!$v.middlename.$invalid"
                    ref="middlename"/>
            </div>
          </div>

          <div class="smd-form__row">
            <div class="smd-form__col">
              <label required
                      normal
                      for="lastname"
                     :error="$v.lastname.$invalid && $v.lastname.$error">
                Last Name
                <span class="form-error-text"
                      v-if="$v.lastname.$invalid && $v.lastname.$error">
                  {{ validationErrors.lastname }}
                </span>
              </label>
              <input  v-model="$v.lastname.$model"
                      type="text"
                      id="lastname"
                      placeholder="Last Name"
                      :error="$v.lastname.$invalid && $v.lastname.$error"
                      :has-value="!$v.lastname.$invalid"
                      ref="lastname"/>
            </div>
          </div>

          <div class="smd-form__row">
            <div class="smd-form__col"
                 :class="{'m-b-10': $mq.desktop}">
              <label required
                    normal
                    for="birthdate"
                    :error="$v.birthdate.$invalid && $v.birthdate.$error">
                Date of Birth
                <span class="form-error-text"
                      v-if="$v.birthdate.$invalid && $v.birthdate.$error">
                  {{ validationErrors.birthdate }}
                </span>
              </label>
              <smd-date-input v-model="$v.birthdate.$model"
                              id="birthdate"
                              placeholder="Date of Birth"
                              :error="$v.birthdate.$invalid && $v.birthdate.$error"
                              :has-value="!$v.birthdate.$invalid"
                              format-emitted-date="MM/DD/YYYY"
                              ref="birthdate"/>
            </div>
          </div>

          <div class="smd-form__row">
            <div class="smd-form__col">
              <label normal
                    required
                    :error="$v.gender.$invalid && $v.gender.$error">
                Sex
                <span class="form-error-text"
                      v-if="$v.gender.$invalid && $v.gender.$error">
                  {{ validationErrors.gender }}
                </span>
              </label>
              <smd-segment class="pill purple-light"
                          v-model="$v.gender.$model"
                          :options="$options.genderOptions"/>
            </div>
          </div>

          <div class="smd-form__row">
            <div class="smd-form__col">
              <label required
                    normal
                    for="mobilenumber"
                   :error="$v.mobilenumber.$invalid && $v.mobilenumber.$error">
                Mobile No.
                <span class="form-error-text"
                      v-if="$v.mobilenumber.$invalid && $v.mobilenumber.$error">
                  {{ validationErrors.mobilenumber }}
                </span>
              </label>
              <smd-phone-input v-model="$v.mobilenumber.$model"
                              id="mobilenumber"
                              ref="mobilenumber"
                              placeholder="9#########"
                              :error="$v.mobilenumber.$invalid && $v.mobilenumber.$error"
                              :has-value="!$v.mobilenumber.$invalid"/>
            </div>
          </div>

          <div class="smd-form__row">
            <div class="smd-form__col">
              <label normal
                    for="email"
                    :error="$v.email.$invalid && $v.email.$error">
                Email
                <span class="form-error-text"
                      v-if="$v.email.$invalid && $v.email.$error">
                  {{ validationErrors.email }}
                </span>
              </label>
              <input v-model="$v.email.$model"
                     id="email"
                     placeholder="Email"
                     :error="$v.email.$invalid && $v.email.$error"
                     :has-value="!$v.email.$invalid"
                     ref="email"/>
            </div>
          </div>
        </div>

        <div class="questions">
          <div v-for="(q, index) in programQuestions"
               :key="index"
               class="smd-form__row m-b-10">
            <div class="smd-form__col">
              <p class="Title3"
                 :class="{'crimson': isQuestionValid(q.question_number),
                          'm-b-10': q.question_type === 'number_text'}">
                 {{q.question}}<span v-if="q.mandatory">*</span>

                 <span class="form-error-text"
                      v-if="isQuestionValid(q.question_number)">
                  {{ isQuestionValid(q.question_number) ? '(Field Required)' : ''}}
                </span>
              </p>

              <template v-if="q.question_type === 'radio'">
                <div v-for="(item, index) in q.choices"
                  :key="index"
                  class="smd-radio__col m-b-10">
                  <smd-radio
                            :label="item.answer"
                            :value="item.answer"
                            :model-value="q.chosen_answer ? q.chosen_answer.answer : ''"
                            @click.native="selectedAnswer(q.question_number, item)"/>
                </div>
              </template>

              <template v-else-if="q.question_type === 'number_text'">
                <input type="number"
                       inputmode="numeric"
                       class="m-b-10"
                       :id="`question${q.question_number}`"
                       :error="isQuestionValid(q.question_number)"
                       :has-value="!$v[`question${q.question_number}`].$invalid"
                       :ref="`question${q.question_number}`"
                       @input="selectedAnswer(q.question_number, $event.target.value)"/>
              </template>

              <p v-else> Unsupported question type. </p>
            </div>
          </div>
        </div>
      </form>

      <div class="freestylelibre-sign-up__terms"
           :class="{'m-b-30': !error}">
        <text-string label-id="txt1454" :props="textStringProps"/>
      </div>

      <div v-if="error"
           class="freestylelibre-sign-up__error-terms m-b-30">
        <smd-note>{{ error }}</smd-note>
      </div>
    </div>

    <vue-hcaptcha :sitekey="$options.siteKey"
                  ref="hcaptcha"
                  size="invisible"
                  @error="onHcaptchaError"
                  @verify="onHcaptchaVerify">
    </vue-hcaptcha>

    <template slot="bottom-nav">
      <smd-btn section="2"
               variant="left-enabled"
               :disabled="loading"
               @click="backToDetails">
        Back
      </smd-btn>
      <smd-btn section="2"
               :variant="computedVariant"
               :disabled="loading"
               type="submit"
               @click="verifyForm">
        Submit
      </smd-btn>
    </template>
  </smd-one-col-layout>
</template>

<script>
  import {mapFields} from 'vuex-map-fields';
  import {
    mapGetters,
    mapActions,
  } from 'vuex';
  import {
    required,
    email,
  } from 'vuelidate/lib/validators';

  import formValidation from '@/mixins/form-validations';
  import hcaptchaMixin from '@/mixins/hcaptcha-mixin';
  import CDEventBusMixin from '@/mixins/content-dictionary-event-bus-mixin';

  import {
    ProgramInviteService,
  } from '@/services/program';

  import ModalTermsAndConditions from '@/modals/modal-terms-and-conditions-freestyle';
  import ModalPrivacyPolicyModal from '@/modals/modal-privacy-policy-freestyle';

  import {genderOptions} from '@/reference/forms';
  import {
    PROGRAM_FREESTYLELIBRE_DETAILS,
    PROGRAM_FREESTYLELIBRE_CONFIRMATION,
  } from '@/reference/program';

  import {
    alphaSpaces,
    mobileNumberValid,
    dateStringIsValid,
    dateStringIsLessThan,
  } from '@/utils/custom-validations';
  import {getAccessToken} from '@/utils/access-token';

  import {
    GETTER_MOBILENUMBER,
    GETTER_PROGRAM_QUESTIONS,
    GETTER_SUBMIT_PROGRAM_BODY,
    ACTION_SET_ANSWER,
  } from '@/store/types';

  const todayInMilli = (new Date()).setHours(0, 0, 0, 0).valueOf();

  export default {
    name: 'freestylelibre-signup',
    mixins: [
      formValidation,
      hcaptchaMixin,
      CDEventBusMixin,
    ],
    data() {
      return {
        error: null,
        targetCDEvents: [
          {
            id: 'txt1454$1',
            handler: this.openTermsAndConditionModal,
          },
          {
            id: 'txt1454$2',
            handler: this.privacyPolicyModal,
          },
        ],
      }
    },
    computed: {
      ...mapFields('program', {
        firstname: 'respondent.firstname',
        middlename: 'respondent.middlename',
        lastname: 'respondent.lastname',
        birthdate: 'respondent.birthdate',
        gender: 'respondent.gender',
        mobilenumber: 'respondent.mobilenumber',
        email: 'respondent.email',
        question1: 'program.questions[0].chosen_answer.remarks',
        question2: 'program.questions[1].chosen_answer',
        question3: 'program.questions[2].chosen_answer',
        question4: 'program.questions[3].chosen_answer',
        termsAgreed: 'termsAgreed',
        privacyAgreed: 'privacyAgreed',
        captchatoken: 'captchatoken',
        accesstoken: 'accesstoken',
        loading: 'loadingstate',
      }),
      ...mapGetters({
        accountMobileNumber: GETTER_MOBILENUMBER,
        programQuestions: `program/${GETTER_PROGRAM_QUESTIONS}`,
        submitProgramBody: `program/${GETTER_SUBMIT_PROGRAM_BODY}`,
      }),
      computedVariant() {
        return this.loading ? 'right-blue-disabled' : 'right-blue-enabled';
      },
      textStringProps() {
        return {
          functions: {
            $1: this.getEventEmitId('txt1454$1'),
            $2: this.getEventEmitId('txt1454$2'),
          }
        }
      },
    },
    mounted() {
      this.mobilenumber = this.accountMobileNumber;
      this.accesstoken = getAccessToken();
    },
    methods: {
      ...mapActions('program', {
        setAnswer: ACTION_SET_ANSWER,
      }),
      backToDetails() {
        this.$emit('set-active-step', PROGRAM_FREESTYLELIBRE_DETAILS);
      },
      verifyForm() {
        if (this.loading) return;

        this.$v.$touch();
        this.submitAttempted = true;

        if (this.$v.$invalid) {
          this.focusOnFieldWithError();
        } else if (!this.termsAgreed || !this.privacyAgreed) {
          this.error = 'Terms and conditions are not accepted.';
        } else {
          this.submitForm();
        }
      },
      selectedAnswer(questionNumber, value) {
        this.setAnswer({question_number: questionNumber, answer: value});
      },
      isQuestionValid(question_num) {
        return this.$v[`question${question_num}`].$invalid && this.$v[`question${question_num}`].$error;
      },
      openTermsAndConditionModal() {
        this.$modal.open({
          component: ModalTermsAndConditions,
          position: 'detached auto-height',
          size: 'xs',
          closeOnBackdrop: false,
        });
      },
      privacyPolicyModal() {
        this.$modal.open({
          component: ModalPrivacyPolicyModal,
          position: 'detached auto-height',
          size: 'xs',
          closeOnBackdrop: false,
        });
      },
      onHcaptchaVerify(token) {
        this.loading = true;
        this.captchatoken = token;
        this.submitForm();
      },
      onHcaptchaError() {
        this.loading = false;
        this.captchatoken = null;
      },
      async submitForm() {
        this.loading = true;

        if (!this.captchatoken) {
          this.triggerCaptcha();
          return;
        }

        try {
          const {data} = await ProgramInviteService.submitCouponProgramInvite(this.submitProgramBody, this.accesstoken);

          if (data.result === 1) {
            this.loading = false;
            this.$emit('set-active-step', PROGRAM_FREESTYLELIBRE_CONFIRMATION);
          } else {
            throw Error();
          }
        } catch (error) {
          this.loading = false;
        }
      },
    },
    validations: {
      firstname: {
        required,
        alphaSpaces,
      },
      middlename: {
        required,
        alphaSpaces,
      },
      lastname: {
        required,
        alphaSpaces,
      },
      birthdate: {
        required,
        dateStringIsValid,
        dateStringIsLessThan: dateStringIsLessThan(todayInMilli),
      },
      gender: {
        required,
      },
      mobilenumber: {
        required,
        mobileNumberValid: mobileNumberValid('mobilenumber', true),
      },
      email: {
        email,
      },
      question1: {
        required,
      },
      question2: {
        required,
      },
      question3: {
        required,
      },
      question4: {
        required,
      },
    },
    genderOptions,
  }
</script>

<style lang="scss">
  @import "@/assets/styles/applications.scss";

  .freestylelibre-sign-up {
    @include flex-col();
    gap: 20px;

    &__header {
      @include flex-col();
      gap: 10px;
    }

    &__form {
      @include flex-col();
      gap: 20px;

      .questions .Title3>span {
        color: color(crimson);
      }

      .smd-segment__item {
        margin-bottom: 0px;
      }
    }

    &__error-terms .smd-note {
      color: color(white, text);
      background-color: color(crimson, brand);
    }

    /* Hide up and down buttons */
    input[type="number"] {
      appearance: none;
      -moz-appearance: none;
      -webkit-appearance: none;
    }
  }
</style>
